// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__Wzqth","errorLogs":"styles_errorLogs__3OsAM"};